import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  CardHeader,
  Media,
  Input,
  Badge,
} from "reactstrap";
import {
  faAngleDown,
  faAngleUp,
  faCheck,
  faCog,
  faHome,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Card,
  Table,
  Button,
  ButtonGroup,
  Breadcrumb,
} from "@themesberg/react-bootstrap";

import {  addTimeLog, getTimeLogs } from "../../../services/employeeWorkService";
import SpinDiv from "../../components/SpinDiv";
import { AddTimeLog } from "./AddTimeLog";
import moment from "moment";
import { throttle,debounce } from "./debounce";
import 'antd/dist/antd.css';
import { Pagination } from 'antd';
import EditTimeLog from "./EditTimeLog";
import DeleteTimeLog from "./DeleteTimeLog";


export class TimeLogIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      page: 1,
      rows: 10,
      loading: false,
      timelogs:[],
      total: 0,

    

    };
    this.searchDebounced = debounce(this.searchTimeLogs, 500);
    this.searchThrottled = throttle(this.searchTimeLogs, 500);
  }

  componentDidMount() {
    this.searchTimeLogs();
  }

  

  searchTimeLogs = () => {
    const { page, rows, search, timelogs } = this.state;
    this.setState({ loading: true });
    getTimeLogs({ page, rows, search, timelogs }).then(

      (res) => {
        this.setState({
          timelogs: res.time_logs.data,
          total:res.time_logs.total,
          loading: false,
        });
      },
      (error) => {
        this.setState({ loading: false });
      }
    );
  };

 

  onChange = (e, state) => {
    this.setState({ [state]: e });
  };

  onPage = async (page,rows) => {
    await this.setState({page,rows});
    await this.searchTimeLogs();
  }
  
  handleSearch = event => {
    this.setState({ search: event.target.value }, () => {
      if(this.state.search < 5){
        this.searchThrottled(this.state.search);
      }else{
        this.searchDebounced(this.state.search);
      }
    
    });
  };
  
  toggleDeleteTimeLog=(deleteTimeLog)=>{
    this.setState({deleteTimeLog});
  }

  toggleEditTimeLog = (timelog) => {
    this.setState({ timelog});
    this.searchTimeLogs();
   
  };
  toggleCloseTimeLog=(timelog)=>{
    this.setState({ timelog: !this.state.timelog });
    this.searchTimeLogs();
  }

 

  toggleAddTimeLog = () => {
    this.setState({ addTimeLog: !this.state.addTimeLog });
    this.searchTimeLogs();
  }

  
  



  formatCurrency(x) {
    if (x !== null && x !== '0' && x !== undefined) {
        const parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return `${parts.join(".")}`;
    }
    return '0';
}




  

  render() {
    const { timelogs,  timelog, deleteTimeLog, total, page, rows, search, loading,addTimeLog, editTimeLog } = this.state;
    
    return (
      <>
       
        
        {addTimeLog && (
          <AddTimeLog
            saved={this.searchTimeLogs}
        
            toggle={this.toggleAddTimeLog}
            
          />
        )}

        {timelog && (
          <EditTimeLog
            saved={this.searchTimeLogs}
            timelog={timelog}
            toggle={this.toggleCloseTimeLog}
          />
        )}

        
        {deleteTimeLog && (
          <DeleteTimeLog
            saved={this.searchTimeLogs}
            deleteTimeLog={deleteTimeLog}
            toggle={() => this.setState({ deleteTimeLog: null })}
          />
        )}


      
       
        {loading && <SpinDiv text={"Loading..."} />}

        <Row style={{}}>
          <Col lg="12">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
              <div className="d-block mb-4 mb-md-0">
                <Breadcrumb
                  listProps={{
                    className: " breadcrumb-text-dark text-primary",
                  }}
                >
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item href="#users">Time Logs</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <div className="btn-toolbar mb-2 mb-md-0">
                <ButtonGroup>
                  <Button variant="outline-primary" size="sm" onClick={() => this.toggleAddTimeLog()}>
                    Create Time Log
                  </Button>
                </ButtonGroup>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="8">
          <h5 className="mb-0">Timelog
          <span style={{color: '#aaa', fontSize: 14, fontWeight: 'normal'}}> ({total})</span></h5>
          </Col>
          <Col lg="4" className="">
            <div style={{ display: "flex" }}>
              <Input
                placeholder="Search..."
                autoFocus
                id="show"
                value={search}
                style={{ maxHeight: 45, marginRight: 5, marginBottom: 10 }}
                onChange={this.handleSearch}
                
              />
            </div>
          </Col>
        </Row>

        <Card border="light" className="shadow-sm mb-4">
          <Card.Body className="pb-0">
            <Table
              responsive
              className="table-centered table-nowrap rounded mb-0"
            >
              <thead className="thead-light">
                <tr>
                <th className="border-0">Employee</th>
                  <th className="border-0">Task</th>
                  <th className="border-0">Start Date</th>
                  <th className="border-0">End Date</th>
                  <th className="border-0">Status</th>
                  <th className="border-0">Duration</th>
                 
                  <th className="border-0">Actions</th>
                </tr>
              </thead>
              <tbody>
                
                {timelogs.map((timelog, key) => {
               
                  return (
                    <tr >
                     <td>
                        <span style={{fontWeight:"bold",textTransform:"capitalize"}}>{timelog.employee_name}</span>
                      </td>
                      <td>
                        <span style={{fontWeight:"bold",textTransform:"capitalize"}}>{timelog.task_name}</span>
                      </td>
                     
                     
                      
                      <td style={{fontWeight:"bold",textTransform:"capitalize"}}>{moment(timelog.start_date).format('MMM D, YYYY')}{' '+timelog.start_time}</td>
                      <td style={{fontWeight:"bold",textTransform:"capitalize"}}>{moment(timelog.end_date).format('MMM D, YYYY')}{' '+timelog.end_time}</td>
                      <td style={{fontWeight:"bold",textTransform:"capitalize"}}>
                        {timelog.status == 1 ? <><span style={{color:'green'}}>●</span><span>Approved</span> </> : <><span style={{color:'orange'}}>●</span><span>Pending</span> </>}
                      </td>
                      <td style={{fontWeight:"bold",textTransform:"capitalize"}}>{timelog.duration}Hrs</td>
                    
                      <td>
                        
                        <ButtonGroup>
                          <Button variant="outline-primary" 
                          style={{fontWeight:"bold",textTransform:"capitalize"}} 
                          onClick={() => this.toggleEditTimeLog(timelog)} size="sm">view</Button>
                          {/* <Button
                            variant="outline-danger"

                            size="sm"
                            onClick={() => this.toggleDeleteTimeLog(timelog)}

                          >
                            Delete
                          </Button> */}
                        </ButtonGroup>
                      </td>

                      
                      
                    </tr>
                  );
                })}
              </tbody>
             
            </Table>
            <Row>
              <Col md={12} style={{fontWeight:"bold",paddingTop:3}}>
              {timelogs.length<1&&
                <div style={{color: '#ccc', alignSelf: 'center', padding: 10, fontSize: 13}}>
                  <i className="fa fa-ban" style={{marginRight: 5}}/>
                  No Timelogs Created yet
                </div>}
              {timelogs.length > 0 && <Pagination
                  total={total}
                  showTotal={total => `Total ${total} timelogs`}
                  onChange={this.onPage}
                  pageSize={rows}
                  current={page}
                />}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export default TimeLogIndex;
